import ExamNavigation from './ExamNavigation';

export default ExamNavigation;
